import React, { Component, Fragment } from "react";
import { I18n } from "react-redux-i18n";

import Icon from "@alboompro/boom-components/general/icon";

import EditorLabel from "editor/components/EditorLabel";
import FAQManagerModal from "./Modal";

import {
  CustomPropListItem,
  CustomPropLabel,
  IconWrapper,
} from "./styles";

class FAQManager extends Component {
  constructor(props) {
    super(props);
    this.state = {
      visible: false,
    };
  }

  handleClose = () => {
    this.setState({ visible: false });
  };

  openModal = () => {
    this.setState({ visible: true });
  };

  render() {
    const { visible } = this.state;

    const { tooltip, locale, label, currentValue } = this.props;
    const tooltipText = tooltip?.locale ?? null;
    const faqCounter = currentValue?.length ?? 0

    return (
      <Fragment>
        <CustomPropListItem>
          <CustomPropLabel>
            <EditorLabel tooltip={tooltipText}>{label[locale]}</EditorLabel>
            <IconWrapper>
              <div className="faqCounter">
                <span>{I18n.t("editPanel.FAQManager.questionsQuantity")}:</span>
                <span>{faqCounter}</span>
              </div>
              <span className="switch" onClick={this.openModal}>
                <Icon
                  kind="regular"
                  group="interface-essential"
                  category="multimedia-controls"
                  file="button-refresh-arrows.svg"
                  size="12"
                  color="#fff"
                />
                {I18n.t("editPanel.FAQManager.manageQuestions")}
              </span>
            </IconWrapper>
          </CustomPropLabel>
        </CustomPropListItem>
        {visible && (
          <FAQManagerModal 
            visible={visible} 
            handleClose={this.handleClose} 
            {...this.props} 
          />
        )}
      </Fragment>
    );
  }
}

export default FAQManager;